export default "__VITE_ASSET__CZ2gcWVN__"